import React from 'react'
import { Sparkles, Zap, Code2, Globe } from 'lucide-react'

const suggestions = []

export default function WelcomeScreen({ userInfo, onSuggestion, onCreate }) {
  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 24px',
      gap: '32px',
    }}>
      {/* Logo */}
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 128,
          height: 96,
          background: 'var(--accent)',
          borderRadius: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          boxShadow: '0 8px 32px rgba(18, 16, 163, 0.25)',
        }}>
          <img src='/images/fmt_logo.png' width={108} />
        </div>
        <h1 style={{
          fontSize: '1.9rem',
          fontWeight: 600,
          color: 'var(--text-primary)',
          marginBottom: 8,
        }}>
          FMT GPS Izveštaji
          {userInfo.master?.title && (
            <>
              <br />
              {userInfo.master.title}
            </>
          )}          
          <br/>
          {userInfo.user_info?.title}
        </h1>
        <p style={{ color: 'var(--text-primary)', fontSize: 15 }}>
          Unesite pitanje koje želite
        </p>
      </div>

      {/* Suggestions grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '10px',
        maxWidth: 600,
        width: '100%',
      }}>
        {suggestions.map((s, i) => (
          <button
            key={i}
            onClick={() => onSuggestion(s.text)}
            style={{
              background: 'var(--bg-input)',
              border: '1px solid var(--border)',
              borderRadius: '12px',
              padding: '14px 16px',
              textAlign: 'left',
              cursor: 'pointer',
              color: 'var(--text-secondary)',
              fontSize: 13,
              fontFamily: 'var(--font-sans)',
              lineHeight: 1.5,
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              transition: 'all var(--transition)',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'var(--bg-hover)'
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.14)'
              e.currentTarget.style.color = 'var(--text-primary)'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'var(--bg-input)'
              e.currentTarget.style.borderColor = 'var(--border)'
              e.currentTarget.style.color = 'var(--text-secondary)'
            }}
          >
            <span style={{ color: 'var(--accent)' }}>{s.icon}</span>
            {s.text}
          </button>
        ))}
      </div>
    </div>
  )
}
